import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { fadeInUp, viewportConfig } from '../../utils/animations';

const SectionTitle = ({
  overline,
  title,
  subtitle,
  align = 'center',
  light = false,
  maxWidth = 700,
}) => {
  const textColor = light ? 'common.white' : 'text.primary';
  const subtitleColor = light ? 'rgba(255, 255, 255, 0.8)' : 'text.secondary';
  const accentColor = light ? 'secondary.main' : 'secondary.main';

  return (
    <Box
      component={motion.div}
      initial="hidden"
      whileInView="visible"
      viewport={viewportConfig}
      variants={fadeInUp}
      sx={{
        textAlign: align,
        maxWidth: maxWidth,
        mx: align === 'center' ? 'auto' : 0,
        mb: { xs: 4, md: 6 },
      }}
    >
      {overline && (
        <Typography
          variant="overline"
          component="span"
          sx={{
            color: accentColor,
            display: 'block',
            mb: 1.5,
            fontWeight: 600,
          }}
        >
          {overline}
        </Typography>
      )}
      <Typography
        variant="h2"
        component="h2"
        sx={{
          color: textColor,
          mb: subtitle ? 2 : 0,
          fontWeight: 700,
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            color: subtitleColor,
            fontSize: { xs: '1rem', md: '1.125rem' },
            lineHeight: 1.7,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

SectionTitle.propTypes = {
  overline: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  light: PropTypes.bool,
  maxWidth: PropTypes.number,
};

export default SectionTitle;
